export const PRODUCT_LINE = {
  SUPER_IMPACT: 'SuperImpact',
  SUPER_VIEW: 'SuperView',
  LINE_TODAY: 'LINEToday'
}

export const PRODUCT_LINES = Object.values(PRODUCT_LINE)
